<ng-content select="[header]"></ng-content>
<ng-content select="[description]"></ng-content>
<form [formGroup]="form" (ngSubmit)="onSubmit($model)">
  <ng-content select="[top]"></ng-content>
  <formly-form [form]="form" [fields]="$fields" [model]="$model"> </formly-form>
  <ng-content select="[bottom]"></ng-content>
  <ng-content select="[type=submit]"></ng-content>
</form>
